<template>
    <div class="navbar">
        <div class="navbar-logo">
            <router-link :to="{name: 'home'}"
                         title="Группа компаний Ренна">Группа компаний Ренна</router-link>
        </div>
        <div class="navbar-control">
            <div class="navbar-menu"
                 title="Меню"
                 @click="click"
            ><span></span></div>
        </div>
        <div class="menu-social">
            <ul class="social">
                <li class="social-item"><a href="https://vk.com/korovka_iz_korenovki"
                                           target="_blank"
                                           class="vk"></a></li>
                <li class="social-item"><a href="https://www.facebook.com/korovka.iz.korenovki.official/"
                                           target="_blank"
                                           class="fb"></a></li>
                <li class="social-item"><a href="https://www.youtube.com/user/Korenovka"
                                           target="_blank"
                                           class="yo"></a></li>
                <!--<li class="social-item"><a href="javascript:;"-->
                <!--target="_blank"-->
                <!--class="tw"></a></li>-->
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NavBar",
        methods: {
            click() {
                this.$emit("click");
            }
        }
    }
</script>